import { Observable, ObservableArray } from 'knockout'

export interface JSONParticipant {
    PersonId?: string

    AnonymousName?: string
    FullName?: string
    FirstName?: string
    LastName?: string
    ImageURL?: string

    Status?: number
    SortOrder?: number

    CommentsCount?: number
    RepliesCount?: number

    IsFollowed?: boolean
    IsOnline?: boolean
    IsModerator?: boolean
    IsObserver?: boolean    
    
    TaskMemberTagIds?: Array<string>
}

export default class Participant {
    personId: Observable<string | undefined>

    anonymousName: Observable<string | undefined>
    fullName: Observable<string | undefined>
    firstName: Observable<string | undefined>
    lastName: Observable<string | undefined>
    imageURL: Observable<string | undefined>

    status: Observable<number | undefined>
    sortOrder: Observable<number | undefined>

    commentsCount: Observable<number>
    repliesCount: Observable<number>

    isFollowed: Observable<boolean>
    isOnline: Observable<boolean>
    isModerator: Observable<boolean>
    isObserver: Observable<boolean>

    taskMemberTagIds: ObservableArray<string>

    constructor(data?: JSONParticipant) {
        this.personId = ko.observable(data?.PersonId);

        this.anonymousName = ko.observable(data?.AnonymousName);
        this.fullName = ko.observable(data?.FullName);
        this.firstName = ko.observable(data?.FirstName);
        this.lastName = ko.observable(data?.LastName);
        this.imageURL = ko.observable(data?.ImageURL);

        this.status = ko.observable(data?.Status);
        this.sortOrder = ko.observable(data?.SortOrder);

        this.commentsCount = ko.observable(data?.CommentsCount ?? 0);
        this.repliesCount = ko.observable(data?.RepliesCount ?? 0);

        this.isFollowed = ko.observable(data?.IsFollowed ?? false);
        this.isOnline = ko.observable(data?.IsOnline ?? false);
        this.isModerator = ko.observable(data?.IsModerator ?? false);
        this.isObserver = ko.observable(data?.IsObserver ?? false);
        

        this.taskMemberTagIds = ko.observableArray(data?.TaskMemberTagIds ?? []);
    }
}